import { defineMessages } from 'react-intl';

export default defineMessages({
  closed: {
    id: 'webshopclose.closed',
    description: 'webshop closed message',
    defaultMessage: 'The webshop is currently closed',
  },

  timePrefix: {
    id: 'webshopclose.timePrefix',
    description: 'webshop close time prefix message',
    defaultMessage: 'You have',
  },

  timeSuffix: {
    id: 'webshopclose.timeSuffix',
    description: 'webshop close time suffix message',
    defaultMessage: 'to submit your order.',
  },
});
